import { render, staticRenderFns } from "./MediaUpload.vue?vue&type=template&id=fb3156f2&scoped=true&"
import script from "./MediaUpload.vue?vue&type=script&lang=js&"
export * from "./MediaUpload.vue?vue&type=script&lang=js&"
import style0 from "./MediaUpload.vue?vue&type=style&index=0&id=fb3156f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3156f2",
  null
  
)

export default component.exports